/**
 * A provider redirect that fails comes back as `#error=…&error_description=…`
 * on the redirect target rather than as a rejected promise, so the only way to
 * tell the user anything is to read the fragment. Returns the message to show,
 * or null when the fragment carries no error.
 */
export function readOAuthErrorFromHash(hash: string): string | null {
  const params = new URLSearchParams(hash.replace(/^#/, ""));
  const description = params.get("error_description");
  if (description) return description;
  return params.get("error");
}
